import { ref, readonly } from "vue";

const correlationId = ref<string>("");

export const useCorrelationId = () => {
  const generateNewCorrelationId = () => {
    const newId = crypto.randomUUID();
    correlationId.value = newId;

    return newId;
  };

  return {
    correlationId: readonly(correlationId),
    generateNewCorrelationId,
  };
};
